import { render, staticRenderFns } from "./WealthStatementsList.vue?vue&type=template&id=5a02dc80&"
import script from "./WealthStatementsList.vue?vue&type=script&lang=ts&"
export * from "./WealthStatementsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports